import styled, { css } from 'styled-components'

import { jsonSyntaxHighlight } from '~/helpers'

const styles = {
  string: { color: 'green' },
  number: { color: 'darkorange' },
  boolean: { color: 'blue' },
  null: { color: 'magenta' },
  key: { color: 'red' }
}

const JsonHighlightStyled = styled.div`
  ${() => css`
    ${Object.keys(styles).map(
      key => `.${key} { color: ${styles[key].color}; }`
    )}
  `}
`

interface JsonHighlightProps {
  data: object
}

const JsonHighlight: React.FC<JsonHighlightProps> = ({ data }) => {
  return (
    <JsonHighlightStyled
      dangerouslySetInnerHTML={{ __html: jsonSyntaxHighlight(data) }}
    />
  )
}

export default JsonHighlight
